<template>
  <div>
    <div class="banner">
      <div class="container">
        <el-row>
          <el-col :span="12">
            <span><a class="ise-top" @click="homeNav('/home')">ISE 学者评价</a></span>
            <div class="search-box">
              <el-dropdown @command="handleCommand" class="search-item1" trigger="click">
                <span class="el-dropdown-link">
                  {{searcheKey}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="姓名">搜姓名</el-dropdown-item>
                  <el-dropdown-item command="单位">搜单位</el-dropdown-item>
                  <el-dropdown-item command="研究领域">搜研究领域</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-input class="search-item2" :class="{'browser': browser===2}" v-model="input" :placeholder="placeholder"></el-input>
              <span @click="searchBtn" class="iconfont icon-sousuo"></span>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="text-align:right;" class="search-box clearfix">
              <el-col :span="6">
                <div class="search-items">
                  <a @click="homeNav('/home')">学者榜单</a>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="search-items">
                  <a @click="homeNav('/introduce')">关于ISE评价</a>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="search-items">
                  <a @click="openVn">申请上榜</a>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="search-items">
                  <a
                    v-if="!getcookie"
                    href="https://v.dmr.cn/login/index?returnurl="
                    target="_self"
                  >登录｜注册</a>
                  <a v-else @click="personal">学者中心</a>
                </div>
              </el-col>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="mt70"></div>
    <!-- <router-view></router-view> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import https from "../common/http.js";
import { getCookie } from "../common/util.js";
function judgmentBrowser() {
  var ua = navigator.userAgent;
  if (/firefox/i.test(ua)) {
    return 2
  } else if (/chrome/i.test(ua)) {
    // alert("你是Chrome");
  } else if (/msie/i.test(ua)) {
    // alert("你是IE");
  } else if ("ActiveXObject" in window) {
    // alert("你是IE11");
  }
}
export default {
  data() {
    return {
      show: true,
      input: this.$store.state.searchInput.value,
      searcheKey: "搜姓名",
      placeholder: "请输入学者姓名",
      command: "姓名",
      getcookie: getCookie("1xuezhePC_LoginMid"),
      browser: judgmentBrowser()
    };
  },
  methods: {
    loginPost() {
      let params = {};
      let _this = this;
      https
        .fetchPost("/iseapi/getisetreecode", params)
        .then(res => {
          if (res.error === 0) {
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleCommand(command) {
      this.command = command;
      this.input = ""
      this.searcheKey = "搜" + command;
      this.placeholder = "";
      this.placeholder = "请输入学者" + command;
    },
    searchBtn() {
      if (this.input) {
        this.$store.commit("mutationsChangeInput", {
          key: this.command,
          value: this.input
        });
        this.$router.push({
          path: "/search"
        });
      } else {
        this.openEn()
      }
    },
    personal() {
      this.openVn()
      //后面开放
      // this.$router.push({
      //   path: "/personalcenter/claimscholar",
      //   query: { num: 0 }
      // });
    },
    homeNav(s) {
      this.$router.push({
        path: `${s}`
      });
    },
    openVn() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [h("span", null, "即将开放，敬请期待 ")]),
        offset: 100
      });
    },
    openEn() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [h("span", null, "请输入关键词")]),
        offset: 100
      });
    }
  },
  created() {}
};
</script>

<style>
.ise-top:hover{
  color: #fff !important;
}
.mt70 {
  margin-top: 70px;
}
.clfff {
  color: #fff;
}
.clfff:hover {
  color: #fff !important;
}
.banner {
  height: 70px;
  width: 100%;
  min-width: 1200px;
  z-index: 10001;
  background: rgba(41, 51, 82, 1);
  line-height: 70px;
  color: #fff;
  position: fixed;
  top: 0;
}
.search-box {
  display: inline;
  position: relative;
}
.search-box .iconfont {
  position: absolute;
  right: 0;
  top: -11px;
  height: 40px;
  line-height: 40px;
  z-index: 100;
  color: #000;
  font-size: 22px;
  padding: 0 30px 0 10px;
  font-weight: 700;
  cursor: pointer;
  /* background-color: #fff; */
}
.search-box .search-item2 {
  width: 320px;
  
}
.browser{
  top: 1px;
}
.search-box .search-items {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  display: inline-block;
}
.search-box .search-items a {
  color: rgba(255, 255, 255, 0.5);
  font-weight: bold;
}
.search-box .search-items a:hover {
  color: rgba(255, 255, 255, 1) !important;
}

.search-box .el-input__inner {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 60px 0 15px;
}
.el-dropdown-link {
  display: inline-block;
  cursor: pointer;
  color: #333333;
  height: 40px;
  line-height: 40px;
  background: #fff;
  padding: 0 20px;
  position: relative;
  left: 10px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: inline-block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.el-popper[x-placement^="bottom"] {
  margin-top: -5px;
}
.icon-sousuo {
  transition: 0.1s;
}
.icon-sousuo:hover {
  color: #4267b2;
  transition: 0.1s;
}

</style>


// WEBPACK FOOTER //
// src/view/Home.vue